


































import { Component, Vue, Prop } from 'vue-property-decorator';
import NetworkForm from './NetworkForm.vue';
import NetworkTemplates from './NetworkTemplates.vue';
import { Network, NetworkTemplate } from '@/types';
import NetworkMerchants from './NetworkMerchants.vue';

@Component({
  name: 'network-create',
  components: {
    NetworkForm,
    NetworkTemplates,
    NetworkMerchants
  }
})
export default class NetworkCreate extends Vue {
  private network: Network = {};
  private networkSaved: boolean = false;
  private networkId: number | null = null;
  private templates: NetworkTemplate[] = [];

  onNetworkSaved(network: Network) {
    this.network = network;
    this.networkSaved = true;
    this.networkId = network.id as number;
    this.templates = network.templates as NetworkTemplate[];
  }
}
